/**
 * Returns an array of elements from `array1` that are not present in `array2`.
 *
 * @param {Array} array1 - The array to check for missing fields.
 * @param {Array} array2 - The array containing fields to validate against.
 * @returns {Array} An array of fields from `array1` that are not found in `array2`.
 */
function getMissingFields(array1, array2) {
  const validationSet = new Set(array2);
  return array1.filter(f => !validationSet.has(f));
}

export default getMissingFields;
